import { HubMediaCard } from '@/components/Hub/HubMediaCard';
import { LESSON_ACTION_LABEL, lessonLaunchTracking, type LessonState } from '@/pages/Explore/Lessons/lessonState';
import { trackingAttributes } from '@/lib/heap/trackingAttributes';
import 'material-symbols';

export interface HubLessonCardProps {
    title: string;
    state: LessonState;
    onPlay: () => void;
    description?: string | null;
    imageUrl?: string;
}

export const HubLessonCard = ({ title, state, onPlay, description, imageUrl }: HubLessonCardProps) => (
    <HubMediaCard
        title={title}
        description={description}
        imageUrl={imageUrl}
        action={(
            <button
                type="button"
                onClick={onPlay}
                aria-label={`${LESSON_ACTION_LABEL[state]}: ${title}`}
                {...trackingAttributes(lessonLaunchTracking(state, 'hub-sheet', 'hub-lesson'))}
            >
                Play
                <span className="material-symbols-rounded text-lg leading-none" aria-hidden>arrow_forward</span>
            </button>
        )}
    />
);
